import React, { forwardRef, useRef, useState, useEffect } from "react";
import classnames from "classnames";
import styled from 'styled-components';
import IBuildrProps from '../../utilities/IBuildrProps';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';

interface ITabContentProps extends IBuildrProps {
    children: any;
    tabId: number,
    active: boolean;
    showing: boolean;
    tabTitle: string;
    activeAccordion: boolean;
    setActiveAccordion: any
}

export default styled(forwardRef((props: ITabContentProps, ref: any) => {
    const { cmsId, editorClassObj, className, children, tabId, active, showing, tabTitle, activeAccordion, setActiveAccordion } = props;

    const accordionContentRef = useRef(null);
    const [maxHeight, setMaxHeight] = useState(0);
    const [isMobileWidth, setIsMobileWidth] = useState(false);

    useEffect(() => {
        setIsMobileWidth(window.innerWidth < 992);
    }, []);

    useEffect(() => {
        setMaxHeight(activeAccordion ? accordionContentRef.current.scrollHeight : 0);
    }, [activeAccordion])

    return (
        <div ref={ref} data-id={cmsId} className={classnames('w-100', className,  editorClassObj, { 'active': active, 'show': active && showing })}>
            <div className="row d-flex d-lg-none no-gutters" onClick={() => setActiveAccordion(tabId)}>
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <h3 className="m-0">{tabTitle}</h3> 
                    <div className="plus d-flex align-items-center">
                        {activeAccordion ? <AiOutlineMinusCircle /> : <AiOutlinePlusCircle />}
                    </div>
                </div>
            </div>
            <div ref={accordionContentRef} className={classnames('accordion-content', {activeAccordion: activeAccordion})} style={{maxHeight: isMobileWidth ? maxHeight: 'auto'}}>
                <div className="mt-3 mt-lg-0">
                    <div className="row no-gutters">
                        {children}
                    </div>
                    
                </div>

            </div>
        </div>
    );
}))`
display: none;
opacity: 0;
transition: opacity .2s linear;

&.active {
    display: block;
}

&.show {
    opacity: 1;
}

.plus {
    font-size: 1.333rem;
}

@media(max-width:992px) {
    display: block;
    opacity: 1;
    border-bottom: 1px solid black;
    padding: 1rem 0;

    .accordion-content {
        max-height: 0;
        opacity: 0;
        transition: max-height .15s linear;
        overflow: hidden;

        &.activeAccordion {
            opacity: 1;
        }
    }
}
`;
